
import EmailAdapter from "Core/logged/EmailAdapter.js";
import Feature from 'Services/Feature';

window.DocOverview = {

	numformat: { 'name': "", 'currency': "", 'decimals': ".", 'thousands': "", 'currencypos': "", 'precision': "" },
	doctype: null,
	thirdid: null,
	docid: null,
	vat: null,
	isTaxesInc: null,
	rateCategory: null,
	hasRelateds: null,
	relatedsAmount: null,
	docnumber: null,

	init: function() {
        $('.preview_nomsie').show();

        // Doc ident
        this.doctype = $("input[name=doctype]") ? $("input[name=doctype]").val() : "";
        this.step = $("input[name=step]") ? $("input[name=step]").val() : "";
        this.docid = $("input[name=docid]") ? $("input[name=docid]").val() : "";
        this.thirdid = $("input[name=thirdid]") ? $("input[name=thirdid]").val() : "";
        this.docnumber = $("input[name=docnumber]") ? $("input[name=docnumber]").val() : "";

        // Doc properties
        this.vat = $('input[name=hasVat]').val() === 'Y';
        this.isTaxesInc = $('input[name=isTaxesInc]').val() === 'Y';
        this.rateCategory = $('input[name=rateCategory]').val();

        // Relateds => deposit, payment
        this.hasRelateds = $('input[name=hasRelateds]').val() === 'Y';
        this.relatedsAmount = $('input[name=relatedsAmount]').val();

        // init numberformat from doc inputs

        this.numformat.name = $('input[name=numformat_name]').val();
        this.numformat.currency = $('input[name=numformat_currency]').val();
        this.numformat.decimals = $('input[name=numformat_decimals]').val();
        this.numformat.thousands = $('input[name=numformat_thousands]').val();
        this.numformat.currencypos = $('input[name=numformat_currencypos]').val();
        this.numformat.precision = $('input[name=numformat_precision]').val();


        if ($('#marge').length > 0) {
            purchaseTools.initMarge();
        }

        //for invoice, do action is triggered in DocOverview.vue
        if (this.doctype !== "invoice") {
            DocOverview.doAction(Persistent.get("afterRecording"));

            let urlParams = new URLSearchParams(location.search);
            if (urlParams.has('afterRecording')) {
                DocOverview.doAction(urlParams.get('afterRecording'), urlParams.get('id'));
            }
        }

        MyTabs.initVertical('docPreview');

        $('#menu').addClass('menuWithoutText');
        $('#contentDiv').addClass('has-sidebar-closed');

        //disable direcdebit change if doc is locked
        var docIsLocked = $('#isLocked').val();
        if (docIsLocked && $('#directdebit_plugins').length) {
            $('input[type="radio"]', "#directdebit_plugins").prop('disabled', true);
            $('.form-group label', "#directdebit_plugins").qtip({
                content: {
                    text: Loc.g('Un ordre de prélèvement est en cours. Il n‘est donc pas possible de changer de module de prélèvement sur le document')
                },
                show: {
                    event: 'mouseover'
                },
                style: {
                    classes: 'custom-qtip',
                    def: false,
                },
            });

        }
        Qtip.init();
        MyFacture.stopWait();
    },

	toggleAllowAddonsPay: function (docid, doctype, allowedPayAddon, value) {

		MyFacture.post('doc', { action: 'toggleAllowAddonsPay', docid: docid, doctype: doctype, allowedPayAddon: allowedPayAddon, value: value }, function (data) {
			MyWindow.alert(Loc.g('Modification enregistrée'), { type: "confirm" });

			if (data.status === "error") {
				MyWindow.alert(data.message, { type: "confirm" });
			} else if (data.callback && data.callback == 'reload') {
				Utils.reload();
			}
		}, "json");

	},

	changePreview: function (direction) {

		var numPage = parseInt($('.num').html());
		var maxPage = parseInt($('.nb').html());

		if (direction === 'next' && numPage < maxPage) {

			$('#docPreview div.slide').animate({ left: '-=1225' }, 500);
			$('.num').html(numPage + 1);

		} else if (direction === 'previous' && 1 < numPage) {

			$('#docPreview div.slide').animate({ left: '+=1225' }, 500);
			$('.num').html(numPage - 1);

		}
		DocOverview.updateTools();
	},

	changePreviewEnd: function (direction) {

		var maxPage = parseInt($('.nb').html());

		if (direction === 'next') {

			$('#docPreview div.slide').animate({ left: (-(maxPage - 1) * 1225) }, 500);
			$('.num').html(maxPage);

		} else if (direction === 'previous') {

			$('#docPreview div.slide').animate({ left: 0 }, 500);
			$('.num').html(1);

		}
		DocOverview.updateTools();

	},

	updateTools: function () {

		var numPage = parseInt($('.num').html());
		var maxPage = parseInt($('.nb').html());
		if (maxPage > 1) {

			if (numPage == 1) {
				$('.tools .previous, .tools .previousEnd').addClass('disabled');
				$('.tools .next, .tools .nextEnd').removeClass('disabled');

			} else if (1 < numPage && numPage < maxPage) {

				$('.tools .previous, .tools .previousEnd').removeClass('disabled');
				$('.tools .next, .tools .nextEnd').removeClass('disabled');

			} else if (maxPage == numPage) {

				$('.tools .previous, .tools .previousEnd').removeClass('disabled');
				$('.tools .next, .tools .nextEnd').addClass('disabled');

			}

		} else {
			$('.tools .previous, .tools .previousEnd').addClass('disabled');
			$('.tools .next, .tools .nextEnd').addClass('disabled');
		}

	},

	viewThird: function () {

		var persistent = Persistent.get("docdetails", true);
		var thirdid = persistent.thirdid;

		MyFacture.relocate("third&thirdid=" + thirdid);

	},

	/***		DEPOSITS		***/
	editDeposit: function (depositid, doctype, docid) {

		if ($('#hasDoubleVat').length > 0 && $('#hasDoubleVat').val() == 'Y') {
			var opt = {
				title: Loc.g('Message système'),
				type: 'error',
				buttons: [
					{
						text: Loc.g("Ok"),
						click: function () { $(this).dialog("close"); }
					}
				]
			};

			MyWindow.alert(Loc.g("Un document possédant une double taxe ne peut être converti en facture d'acompte"), opt);

			return;
		}

		depositid = undefined == depositid ? "" : depositid;
		docid = undefined == docid ? "" : docid;
		doctype = undefined == doctype ? "" : doctype;

		var options = {
			title: Loc.g("Facture d'acompte"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () { $(this).dialog("close"); }
				},
				{
					text: Loc.g("Enregistrer"),
					click: function () { $("#docDepositForm").submit(); }
				}
			],
			width: MyWindow.large,
			callback: function () { DocOverview.prepareDepositForm(); }
		};

		var fileOpt = {
			action: "docDepositForm",
			depositid: depositid,
			docid: docid,
			doctype: doctype,
            from: docid
		};

		MyWindow.load("doc", fileOpt, options);
	},

	prepareDepositForm: function () {

		var numformat = DocOverview.numformat;
		var formId = "docDepositForm";

		MyTabs.initHorizontal();

		NumberFormat.applyToDisplay(numformat, "#" + formId);

		if (numformat.currencypos === "left" || numformat.currencypos === "both") {
			$("#pay_currencyleft").html(numformat.currency);
		}

		if (numformat.currencypos === "right" || numformat.currencypos === "both") {
			$("#pay_currencyright").html(numformat.currency);
		}

		var options = {
			success: function (data) {
				DocOverview.recordDepositCallback(data);
			},
			dataType: "json"
		};

		var params = {
			action: 'recordDeposit'
		};

		params = $.extend(true, params, this.numformat);

		// Amount due left
		$("input.amountDisplay").each(function (index, elem) {
			var position = $(elem).attr("position");
			var amount = $("#deposit_amountDueTTC_" + position).val();
			$("#row_amount_due_display_" + position).html(NumberFormat.formatToDisplay(amount, DocOverview.numformat));
		});

		DocDeposit.init();

		$('input[type=checkbox][listname=paymediums][syscode=check]').bind('click', function () {
			var forceDisplayCheckOrder = $('#forceDisplayCheckOrder');
			forceDisplayCheckOrder.prop('checked', $(this).prop('checked'));
		});
		$('input[type=checkbox][listname=paymediums][syscode=transfer]').bind('click', function () {
			var forceDisplayBankAccount = $('#forceDisplayBankAccount');
			forceDisplayBankAccount.prop('checked', $(this).prop('checked'));
		});

		$("#" + formId + " input.updateRow").change(function () {
			$(this).val(NumberFormat.formatToDisplay($(this).val(), DocOverview.numformat));
		});

		$('#formContent').sortable({
			handle: 'a.drag',
			items: '> div',
			opacity: 0.8,
			axis: 'y',
			stop: function (event, ui) {
				DocFormv2.updateSubTotal();
				DocFormv2.updateRank();
			},
			cursorAt: { top: 0, left: 0 },
			cursor: 'move',
			placeholder: 'item_list_placeholder',
			forcePlaceholderSize: true,
			scroll: false,
			containment: 'parent',
			tolerance: 'pointer'
		});

		MyForm.prepare(formId, "doc&" + $.param(params), options, true);
		DocFormv2.changePayDate();

		$(".paymediums").each(function () {
			DocFormv2.clickPayMedium($(this));
		});

		MyTabs.init();
	},

	addDepositRow: function (rowtype) {

		var k = Math.ceil(Math.random() * 1000000);

		var html = '<div class="docrow row ' + rowtype + '">'
			+ '	<table class="table">'
			+ '		<tr auto_mousehoaver="true">'
			+ '			<td class="action">'
			+ '				<a href="javascript:;" class="drag" tips="' + Loc.g("Bouton glisser-déposer pour organiser vos lignes") + '" positiontips="left"><i class="fa fa-arrows-v fa-grey fa-15" style="cursor:move;"><xsl:comment /></i></a>'
			+ '				<input type="hidden" name="row[' + k + '][id]" value="">'
			+ '				<input type="hidden" name="row[' + k + '][type]" value="' + rowtype + '">'
			+ '			</td>';

		switch (rowtype) {
			case 'title':
				html += '<td class="title"><input type="text" name="row[' + k + '][title]" class="wp-10" /></td>';
				break;
			case 'comment':
				html += '<td class="title"><textarea name="row[' + k + '][comment]" class="redactor lightButtons" resizable="20" defaulttext="' + Loc.g('Commentaire') + '"></textarea></td>';
				break;
		}

		html += '			<td class="action"><a href="javascript:;" onclick="DocOverview.deleteDepositRow($(this));" ><i class="fa fa-trash-o fa-grey fa-15"></i></a></td>'
			+ '		</tr>'
			+ '	</table>'
			+ '</div>';

		$('#formContent').append(html);
		MyFacture.customForm();

	},

	deleteDepositRow: function (elt) {

		elt.closest('div.row').slideUp('fast', function () {
			$(this).remove();
		});

	},

	recordDepositCallback: function (data) {

		if (data.form.status === "failed") {

			var msg = data.form.msg;
			if (msg.length > 0) {

				var options = {
					type: "warning",
					resizable: false,
					noclose: false,
					title: Loc.g("Erreur système"),
					buttons: [
						{
							text: Loc.g("Fermer"),
							click: function () {
								$(this).dialog("close");
							}
						}
					]
				};

				MyWindow.alert(msg, options);
			}
		}

		MyForm.processJson(data, "docDepositForm");
	},

	getProperties: function (search) {

		var toSearch = [];
		if (typeof search == 'string') {
			toSearch.push(search);
		} else if (typeof search == "object") {
			toSearch = search;
		}

		var properties = [];
		for (var propertyName in this) {
			if (typeof this[propertyName] != 'function') {
				if (toSearch.length == 0) {
					properties[propertyName] = this[propertyName];
				} else if (toSearch.length != 0 && Utils.in_array(propertyName, toSearch)) {
					properties[propertyName] = this[propertyName];
				}
			}
		}
		return $.extend({}, properties);
	},

	/***		ACTIONS MESSAGES		***/
	isNotConvertible: function () {
		MyWindow.alert(Loc.g("Ce document ne peut plus être converti."), { type: 'error' });
	},

	documentNotConvertibleInInvoice: function () {
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.alert.props = {
			title: window.sellsyapp.config.globalProperties.$t.__('popup.documentNotConvertibleInInvoice.title'),
			message: `
			<p>${window.sellsyapp.config.globalProperties.$t.__('popup.documentNotConvertibleInInvoice.subTitle')}</p>
    	<ul class="withchip">
    		${window.sellsyapp.config.globalProperties.$t.__('popup.documentNotConvertibleInInvoice.list', {
					listItemStart: '<li>',
					listItemEnd: '</li>',
			})}
    	</ul>
		`
		}

		window.sellsyapp.config.globalProperties.$store.state.popupPanel.alert.display = true
	},

	progressInvoiceUncancelable: function (lastProgressInvoiceId) {
		Popup.openPopup({
			key: 'cancelProgressInvoiceDialog',
			props: {
				lastProgressInvoiceId,
			}
		})
	},

	isNotEditable: function (errorMsg) {
		var options = {
			type: 'warning',
			dialogClass: "white",
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
			]
		};
		MyWindow.alert(errorMsg, options);
	},

	/***		DELETION		***/
	isNotDeletable: function () {
		MyWindow.alert(Loc.g("Ce document ne peut plus être supprimé car : <ul><li> - Un ou plusieurs règlements sont liés</li><li> - Le document est envoyé en comptabilité</li><li> - Si c'est une facture d'acompte, le document parent doit être supprimé ou dans un statut différent de facturé</li></ul><br />Nous vous conseillons de créer un avoir. Si ce n'est pas possible, vous devez alors délier les règlements et la comptabilité avant de supprimer le document."), { type: 'error' });
	},

	isStockNotDeletable: function () {
		MyWindow.alert(Loc.g("Ce document n’est pas supprimable car il a des documents enfants et a impacté les stocks. <br /><br /> Pour pouvoir le supprimer, vous devez d'abord supprimer les documents enfants."), { type: 'error' });
	},

	confirmDeletion: function (docClass) {
		var options = {
			dialogClass: "white",
			title: Loc.g("Supprimer un document"),
			close: function () {
				DocOverview.cancelDeletion();
			},
			buttons: [
				{
					text: Loc.g("Annuler"),
					'class': 'btn btn-default',
					click: function () {
						$(this).dialog('close');
					}
				},
				{
					text: Loc.g("Supprimer le document"),
					'class': 'btn btn-primary',
					click: function () {
						eval($('input[name=delaction]').val());
					}
				}
			]
		};

		if (docClass == 'DocModel') {
			MyWindow.alert(Loc.g("Confirmez-vous la suppression de ce modèle de document ?"), options);
		} else {
			MyWindow.alert(Loc.g("La suppression d’un document est définitive. Êtes-vous certains de vouloir supprimer ce document ?"), options);
		}


	},

	cancelDeletion: function () {
		$("#confdel").slideUp(100);
		return true;
	},

	askInvoiceToCreditnote: function (canCreateCreditNote, isDeposit = 'N') {
		canCreateCreditNote = canCreateCreditNote == undefined ? false : canCreateCreditNote;

		if (isDeposit == 'Y') {
			if (canCreateCreditNote) {
				var msg = "Comptablement, il est préférable de générer un avoir plutôt que de supprimer la facture d'acompte. Que voulez vous faire ?";
			} else {
				var msg = "Comptablement, il est préférable de générer un avoir plustot que de supprimer la facture d'acompte. Vous ne disposez cependant pas des droits nécessaire pour créer un avoir. Nous vous conseillons de contacter un administrateur de votre compte avant de supprimer la facture."
			}
		} else {
			if (canCreateCreditNote) {
				var msg = "Comptablement, il est préférable de générer un avoir plutôt que de supprimer la facture. Que voulez vous faire ?";
			} else {
				var msg = "Comptablement, il est préférable de générer un avoir plustot que de supprimer la facture. Vous ne disposez cependant pas des droits nécessaire pour créer un avoir. Nous vous conseillons de contacter un administrateur de votre compte avant de supprimer la facture."
			}
		}
		var msg = Loc.g(msg);

		var btns = [];
		btns.push({
			text: Loc.g("Supprimer la facture"),
			class: 'btn btn-default',
			click: function () {
				DocOverview.do_deleteIt();
			}
		});
		if (canCreateCreditNote) {
			btns.push({
				text: Loc.g("Générer un avoir"),
				class: 'btn btn-primary',
				click: function () {
					DocOverview.convert('creditnoteForm');
				}
			});
		}

		var options = {
			dialogClass: "white",
			title: Loc.g("Générer un avoir"),
			close: function () { DocOverview.cancelDeletion(); },
			buttons: btns,
		};

		MyWindow.alert(msg, options);
	},

	deleteIt: function () {
		var options = {
			dialogClass: "white",
			title: Loc.g("Supprimer le document ?"),
			close: function () {
				DocOverview.cancelDeletion();
			},
			buttons: [
				{
					text: Loc.g("Annuler"),
					'class': 'btn btn-default',
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Supprimer"),
					'class': 'btn btn-primary',
					click: function () {
						DocOverview.do_deleteIt();
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Êtes vous vraiment sûr de vouloir supprimer ce document ?"), options);
	},

	do_deleteIt: function () {
		const doc = DocOverview.getProperties(['docid', 'doctype']);
		const purDoctypes = ['purInvoice', 'purCreditNote', 'purOrder', 'purDelivery'];
		if (purDoctypes.includes(doc['doctype'])) {
			var route = `/rest/purchase/document/${doc['doctype']}/${doc['docid']}`;
		} else {
			var route = `/rest/document/${doc['doctype']}/${doc['docid']}`;
		}

		window.SellsyJS.WebServiceCaller.del(route, {}, (data) => {
			Utils.relocate(data.redirect);
		}, (error) => {
			Push.error(Loc.g('Une erreur est survenue : ' + error));
		})
	},

	modelHasDocGenerated: function () {

		var options = {
			title: Loc.g("Impossible de supprimer le modèle"),
			close: function () {
				DocOverview.cancelDeletion();
			},
			height: 150,
			type: 'warning',
			buttons: [
				{
					text: Loc.g("OK"), click: function () {
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Vous ne pouvez pas supprimer ce modèle car il a été utilisé dans la génération d‘un abonnement."), options);
	},

	/***		EDIT RECURRING		***/
	// See DocRecurring

	/***		PAYMENTS		***/
	editPayment: function (payID, doctype, docid, action) {

		payID = undefined === payID ? "" : payID;
		docid = undefined === docid ? DocOverview.getProperties(['docid']).docid : docid;
		doctype = undefined === doctype ? DocOverview.getProperties(['doctype']).doctype : doctype;
		action = undefined === action ? "doc" : action;

		var formId = "docPaymentForm";

		var options = {
			dialogClass: 'white',
			title: Loc.g('Paiement'),
			width: MyWindow.medium,
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () { $(this).dialog("close"); }
				},
				{
					text: Loc.g("Enregistrer"),
					click: function () { $("#" + formId).submit(); }
				}
			],
			callback: function () {

				var options = {
					beforeSend: function () {
						$('#' + formId + ' .alert').remove();
					},
					success: function (data) {
						var formIsOk = MyForm.processJson(data, "docPaymentForm");
						if (formIsOk) {
							if ($("#docinvoicesListing_container").length > 0) {
								Listing.update("docinvoicesListing");
							} else {
								Utils.reload();
							}

							MyWindow.close();
						} else if (data.form.msg != '') {
							$('#' + formId).prepend('<div class="alert alert-danger">' + data.form.msg + '</div>');
						}
					},
					dataType: "json",
					data: {
						action: 'recordPayment',
						docid: docid,
						doctype: doctype
					}
				};

				$('input[name=pay_email]').unbind('change').bind('change', function () {

					if ($(this).prop('checked')) {
						$('.mail_cc:hidden').slideDown('fast');
						MyFacture.customForm('.mail_cc');
					} else {
						$('.mail_cc:visible').slideUp('fast');
					}
				});

				$('input[name=pay_inBank]').unbind('change').bind('change', function () {
					if ($(this).prop('checked')) {
						$('.bankDetails:hidden').slideDown('fast');
						MyFacture.customForm('.bankDetails');
					} else {
						$('.bankDetails:visible').slideUp('fast');
					}
				});


				$('.pay_deadline').unbind('click').bind('click', function () {

					var amounts = [];
					$('.pay_deadline:checked').each(function () {
						amounts.push(parseFloat($(this).attr('amount'), 10));
					});

					var totalPayAmount = new Big(0);

					for (var i in amounts) {
						var val = new Big(amounts[i]);
						totalPayAmount = totalPayAmount.plus(val);
					}

					const numformat = NumberFormat.loadFromInputs('numpay_');
					const totalPayAmountFormatted = NumberFormat.formatToDisplay(totalPayAmount, numformat)
					$('input[name=pay_amount]').val(totalPayAmountFormatted).trigger('change');
				});

				MyForm.prepare(formId, action, options, true);
				MyFacture.customForm();
			}
		};

		var fileOpt = {
			action: "paymentForm",
			payid: payID,
			docid: docid,
			doctype: doctype
		};

		MyWindow.load(action, fileOpt, options);

	},


	showPaymentHint: function (payid) {
		$("#pay_" + payid + "_hint").toggle();
	},


	deletePayment: function (payID, deletable, action, step) {

		if (action == undefined || action == '') {
			action = "doc";
		}

		var msg = '';
		var buttons = [{
			text: Loc.g("Annuler"),
			click: function () {
				$(this).dialog("close");
			}
		}];


		if (deletable) {
			msg = Loc.g("Le paiement n'est lié qu'à ce document.") + "<br />" + Loc.g("Voulez vous délier le paiement du document ou supprimer le paiement ?");

			buttons.push({
				text: Loc.g("Supprimer le paiement"),
				click: function () {
					DocOverview.doDeletePayement(payID, 'Y', action);
				}
			});

		} else {
			msg = Loc.g("Le paiement est lié à plusieurs documents ou a déjà été remis en banque.") + "<br />" + Loc.g("Voulez vous délier le paiement du document ?");
		}

		if (step != 'pending') {
			buttons.push({
				text: Loc.g("Délier"),
				click: function () {
					DocOverview.doDeletePayement(payID, 'N', action);
				}
			});
		}

		var options = {
			dialogClass: "white",
			buttons: buttons,
		};

		MyWindow.alert(msg, options);
	},

	doDeletePayement: function (payid, fullDelete, action) {

		if (action == undefined) {
			action = "doc";
		}

		if (!Utils.exists("pay_" + payid)) {
			return false;
		}

		var data = {
			action: "deletePayment",
			payid: payid,
			deletePayment: fullDelete
		};

		data = $.extend(true, data, DocOverview.getProperties(['docid', 'doctype']));

		MyFacture.post(action, data, function (data) {
			DocOverview.deletePaymentCallback(data);
		}, "json");

		return true;
	},

	deletePaymentCallback: function (data) {

		if (data.delpayid && Utils.exists("pay_" + data.delpayid)) {
			$("#pay_" + data.delpayid).fadeOut();
			Utils.reload();
		}

	},

	/***		AVOIRS, TRANSFO, COPIE		***/
	convert: function (docFormUrl, cleanUrl = false) {
		if (cleanUrl) {
			Utils.relocate(docFormUrl);
			return;
		}
		var meta = DocOverview.getProperties(['docid']);
		MyFacture.relocate(docFormUrl + "&from=" + meta.docid);
	},

	copy: function (doctype, docid, title, withThird, fromPurchase, thirdId) {

		withThird = withThird == undefined ? true : withThird;
		fromPurchase = fromPurchase == undefined ? false : fromPurchase;
		var action = fromPurchase ? "purchases_purchases" : "doc";

		var options = {
			dialogClass: "white",
			title: title,
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Copier le document"),
					click: function () {
						var options = {
							dialogClass: "white",
							resizable: false,
							title: Loc.g("Choix des préférences du document"),
							width: MyWindow.large,
							buttons: [
								{
									text: Loc.g("Conserver les préférences du document"),
									click: function () {
										copyDoc();
										$(this).dialog("close");

									}
								},
								{
									text: fromPurchase
										? Loc.g("Copier les préférences du fournisseur")
										: Loc.g("Copier les préférences du client"),
									click: function () {
										copyDoc(true);
										$(this).dialog("close");

									}
								}
							]
						};
						let alertLabel = fromPurchase
							? Loc.g("Souhaitez-vous appliquer sur le document copié les préférences du document ou celles du fournisseur ?")
							: Loc.g("Souhaitez-vous appliquer sur le document copié les préférences du document ou celles du client ?");

						MyWindow.alert(alertLabel, options);
					}
				}
			],
			callback: function () {
				DocTools.prepareCreateForThirdForm(action);
			},
			width: MyWindow.large,
			height: "auto",
		};

		var copyDoc = function (applyThirdPrefs) {
			$('#applyThirdPrefs').val((applyThirdPrefs !== undefined && applyThirdPrefs) ? 'Y' : 'N');
			var doctype = $('#docCreateForThirdForm').find('#doctype').val();
			if (doctype == 'order' && $('#docnewthird:checked').length == 0) {
				var third_id = $('#docCreateForThirdForm').find('#docsearchThird').val().split('_')[1];
				window.SellsyJS.WebServiceCaller.get(`/rest/document/order/third/${third_id}/allowed`, {}, (response) => {
					if (response.allowed) {
						$("#docCreateForThirdForm").submit();
					} else {
						$('#alert-client-not-allowed').show();
					}
				});
			} else {
				$("#docCreateForThirdForm").submit();
			}
		};

		var fileOpt = {
			action: "createForThirdForm",
			doctype: doctype,
			copy: true,
			docid: docid,
			withRateCat: 'N',
			withThird: (withThird ? 'Y' : 'N'),
			thirdId: thirdId
		};

		MyWindow.load(action, fileOpt, options);
	},

	transformToModel: function (title) {

		var options = {
			title: title,
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Transformer le document"),
					click: function () {
						$("#docCreateForThirdForm").submit();
					}
				}
			],
			callback: function () {
				DocTools.prepareToModelCallback();
			},
			height: "auto"
		};

		var fileOpt = {
			action: "createForThirdForm",
			doctype: 'model',
			copy: true,
			withThird: 'N'
		};

		MyWindow.load("doc", fileOpt, options);
	},

	transformModel: function (layout, lang) {

		if (layout === undefined) {
			layout = 0;
		}

		if (lang === undefined) {
			lang = 0;
		}

		var docmetas = DocOverview.getProperties(['doctype', 'docid']);

		var options = {
			title: Loc.g('Créer un document à partir du modèle'),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Créer le document"),
					click: function () {

						var doctype = $('#docCreateForThirdForm').find('#doctype').val();
						if (doctype == 'order' && $('#docnewthird:checked').length == 0) {
							var third_id = $('#docCreateForThirdForm').find('#docsearchThird').val().split('_')[1];
							window.SellsyJS.WebServiceCaller.get(`/rest/document/order/third/${third_id}/allowed`, {}, (response) => {
								if (response.allowed) {
									$("#docCreateForThirdForm").submit();
								} else {
									$('#alert-client-not-allowed').show();
								}
							});
						} else {
							$("#docCreateForThirdForm").submit();
						}

					}
				}
			],
			callback: function () {

				DocTools.prepareCreateForThirdForm('doc');
				var doctype = $('#docCreateForThirdForm').find('#doctype');
				DocOverview.transformModelSelect(doctype);
				doctype.bind('change', function () {
					DocOverview.transformModelSelect($(this));
				});
				doctype.trigger('change');
			},
			height: "auto"
		};

		var fileOpt = {
			action: "createForThirdForm",
			doctype: docmetas.doctype,
			copy: false,
			withThird: 'Y',
			model: docmetas.docid,
			withRateCat: 'N',
			layoutid: layout,
			langid: lang
		};

		MyWindow.load("doc", fileOpt, options);
	},

	transformModelSelect: function (el) {
		var value = el.val();

		var thirdChoice = $('#docCreateForThirdForm').find('#docthird_choice');
		var label = thirdChoice.find('.choiceThird').find('label').find('span');
		var input = thirdChoice.find('#docsearchThird');
		var tokenInput = thirdChoice.find('.token-input-list');

		tokenInput.remove();
		input.show();

		if (value === 'estimate') {
			label.text(Loc.g('Pour un client / prospect existant'));
			input.attr('e_autocontactlisting', 'third|prospect');
		} else {
			label.text(Loc.g('Pour un client existant'));
			input.attr('e_autocontactlisting', 'third');
		}
		MyFacture.initEvent('#docthird_choice');
	},

	/***		STEPS		***/
	toggleSteps: function (force) {

		force = undefined == force ? "" : force;
		var isVisible = "none" != $("#stepsList").css("display");

		if (isVisible || force === 'open') {
			return $("#stepsList").slideUp(100);
		}

		if (!isVisible || force === 'close') {
			return $("#stepsList").slideDown(100);
		}

		return true;

	},

	toggleDoctypeSteps: function (force) {

		force = undefined == force ? "" : force;
		var isVisible = "none" != $("#doctypeStepsList").css("display");

		if (isVisible || force === 'open') {
			return $("#doctypeStepsList").slideUp(100);
		}

		if (!isVisible || force === "close") {
			return $("#doctypeStepsList").slideDown(100);
		}
		return true;

	},

	toggleDeliverySteps: function (force) {

		force = undefined == force ? "" : force;
		var isVisible = "none" != $("#deliverystepsList").css("display");

		if (isVisible || force === 'open') {
			return $("#deliverystepsList").slideUp(100);
		}

		if (!isVisible || force === 'close') {
			return $("#deliverystepsList").slideDown(100);
		}
		return true;

	},

	toStep: function (nextStep, fromPurchases) {

		if (fromPurchases == "undefined") {
			fromPurchases = false;
		}

		if (fromPurchases) {
			var action = "purchases_purchases";
		} else {
			var action = "doc";
		}

		var datas = {
			action: "step",
			step: nextStep
		};

		datas = $.extend(true, datas, DocOverview.getProperties(['docid', 'doctype']));

		return MyFacture.post(action, datas, function (data) {
			DocOverview.toStepCallback(data);
		}, "json");

	},

	warningStepInvoice: function () {
		var options = {
			type: "warning",
			title: Loc.g("Changement de statut"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("OK"),
					click: function () {
						$(this).dialog("close");
						DocOverview.toStep('invoiced');
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Attention : Vous allez mettre ce document en statut ’facturé’ sans générer de facture.'), options);
	},

	toDoctypeStep: function (nextStep) {

		var action = "doc";
		var datas = {
			action: "doctypestep",
			step: nextStep
		};

		datas = $.extend(true, datas, DocOverview.getProperties(['docid', 'doctype']));

		return MyFacture.post(action, datas, function (data) {
			DocOverview.toStepCallback(data);
		}, "json");

	},

	toDeliveryStep: function (nextStep) {

		var datas = {
			action: "deliveryStep",
			step: nextStep
		};
		datas = $.extend(true, datas, DocOverview.getProperties(['docid', 'doctype']));

		return MyFacture.post("purchases_purchases", datas, function (data) {
			DocOverview.toStepCallback(data);
		}, "json");

	},

	toStepCallback: function (data) {
		if (data.error !== undefined) {
			Push.error(Loc.g("Une erreur est survenue, merci de contacter le support"));
			return;
		} else {
			Utils.reload();
		}
	},

	warnBilled: function (type) {
		var options = {
			title: Loc.g("Facturer le document"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Créer une facture"),
					click: function () {
						if (type === 'sales') {
							DocOverview.convert('invoiceForm');
						}
						else {
							DocOverview.convert('purchases_purInvoiceForm');
						}
					}
				},
				{
					text: Loc.g("Ne pas créer de facture"),
					click: function () {
						if (type === 'sales') {
							DocOverview.toStep('invoiced');
						}
						else {
							DocOverview.toStep('invoiced', true);
						}
					}
				}
			],
			type: 'warning'
		};

		MyWindow.alert(Loc.g('Vous allez mettre ce document en statut ’facturé’, que souhaitez-vous faire ?'), options);
	},

	/***		CHASE		***/
	chase: function (doctype, docid) {

		var docmetas = DocOverview.getProperties(['docid', 'doctype']);
		if (undefined == doctype) {
			doctype = docmetas.doctype;
		}

		if (undefined == docid) {
			docid = docmetas.docid;
		}

		Email.chaseDoc(doctype, docid);

	},

	loadChasesList: function (doctype, docid, canMail, element, onboardingIsSetup, fileId = null, docIdent = null) {
		var canMail = canMail === undefined ? 'N' : canMail;
		var buttons = [];

		switch (doctype) {
			case 'invoice':
				buttons = [
					{
						text: Loc.g("Relancer par email"),
						click: function () {
							if (Feature.isEnabled('email-engine')) {
								MyWindow.close();
								window.EventBus.emit(
									'email:sendDocument',
									{
										docId: docid,
										doctype,
										type: 'manual_document_reminder',
										fileId,
										docIdent
									}
								);
							} else {
								if (onboardingIsSetup == 'N') { OnboardingEmail.goToParameters('/?_f=onboarding&action=email'); }
								else {
									if ($(element).hasClass('nylas-is-sync')) {
										MyWindow.close();
										EmailBox.create(docid, doctype, 'N', 'chaseDoc');
									}
									else { DocOverview.chase(doctype, docid); }
								}
							}
						}
					}
				];

				if (canMail === 'Y') {
					buttons.push(
						{
							text: Loc.g("Relance Amiable"),
							click: function () {
								Mail.edit('doc', docid, 'reminder');
							}
						},
						{
							text: Loc.g("Mise en demeure"),
							click: function () {
								Mail.edit('doc', docid, 'notice');
							}
						}
					);
				}
				break;

			case 'estimate':
				buttons = [
					{
						text: Loc.g("Annuler"),
						click: function () {
							MyWindow.close();
						}
					},
					{
						text: Loc.g("Relancer par email"),
						click: function () {
							if (Feature.isEnabled('email-engine')) {
								MyWindow.close();
								window.EventBus.emit('email:sendDocument', {docid, doctype, type: 'manual_document_reminder' });
							} else {
								if (onboardingIsSetup == 'N') {
									OnboardingEmail.goToParameters('/?_f=onboarding&action=email');
								} else {
									if ($(element).hasClass('nylas-is-sync')) {
										MyWindow.close();
										EmailBox.create(docid, doctype, 'N', 'chaseDocEstimate');
									} else {
										DocOverview.chase(doctype, docid);
									}
								}
							}
						}
					}
				];

				if (canMail === 'Y') {
					buttons.push({
						text: Loc.g("Relancer par courrier"),
						click: function () {
							Mail.edit('doc', docid, 'noticeEstimate');
						}
					});
				}

				break;

		}
		var options = {
			dialogClass: "white",
			title: Loc.g("Relance"),
			width: MyWindow.medium,
			buttons: buttons
		};

		var fileOpt = {
			action: "listChase"
		};

		fileOpt = $.extend(true, fileOpt, { doctype: doctype, docid: docid });
		MyWindow.load("doc", fileOpt, options);

	},

	/***		DROPBOX, PRINT, EMAILS		***/
	sendToDropbox: function (doctype, fileId) {

		var datas = {
			action: "syncDocToDropbox",
			fileId: fileId,
			doctype: doctype
		};

		$("#actionBtn\\[dropbox\\]").css('position', 'relative').append('<img style="position:absolute;right:5px;top:1px;" id="dropboxloader" src="/ressources/logged/img/common/loader.gif"/>');

		MyFacture.send("briefcasev2", datas, function (data) {
			if (data != null && data.errorDropbox) {
				var options = {
					dialogClass: "white",
					resizable: false,
					noclose: true,
					title: Loc.g("Synchronisation Dropbox"),
					buttons: [
						{
							text: Loc.g("Valider"), click: function () {
								$(this).dialog("close");
							}
						}
					]
				};
				MyWindow.alert(data.errorDropbox, options);
			} else {
				MyWindow.alert(Loc.g("La demande de synchronisation a été ajoutée à la file d'attente, votre document sera disponible dans quelques instants sur votre dépôt Dropbox") + ".", { dialogClass: "white" });
				$("#dropboxloader").remove();
			}
		}, "json");
	},

	getPdf: function (fromPurchases) {

		fromPurchases = fromPurchases == undefined ? false : fromPurchases;
		var action = fromPurchases ? "purchases_purchases" : "doc";
		var metas = DocOverview.getProperties(['doctype', 'docid']);

		MyFacture.relocate(action + "&action=pdf&doctype=" + metas.doctype + "&id=" + metas.docid, true);
	},

	print: function (fromPurchases) {

		fromPurchases = fromPurchases == undefined ? false : fromPurchases;
		var action = fromPurchases ? "purchases_purchases" : "doc";
		var metas = DocOverview.getProperties(['doctype', 'docid']);
		var docUrl = action + "&action=pdf&doctype=" + metas.doctype + "&id=" + metas.docid + "&print=y";

		MyFacture.relocate(docUrl, true);

	},

	printFromListing: function (doctype, docid, fromPurchases) {

		fromPurchases = fromPurchases == undefined ? false : fromPurchases;
		var action = fromPurchases ? "purchases_purchases" : "doc";
		var docUrl = action + "&action=pdf&doctype=" + doctype + "&id=" + docid + "&print=y";

		MyFacture.relocate(docUrl);

	},

	createOpportunity: function () {

		var metas = DocOverview.getProperties(['docid']);
		MyFacture.relocate("estimateOverview&createOpp=1&id=" + metas.docid, false);
	},

	emailSending: function () {
		var metas = DocOverview.getProperties(['doctype', 'docid']);

		if (Feature.isEnabled('email-engine')) {
			window.EventBus.emit('email:sendFinalInvoice', {...metas});
		} else {
			EmailAdapter.openSendTab(
				metas.doctype,
				metas.docid,
				{
					relatedid: metas.docid,
					relatedtype: metas.doctype,
					empty: 'N',
				}
			);
		}

	},

	validateAndEmailSending() {
		EventBus.emit('document:validate', 'email');
	},

	doAction: function (action, docid) {
		switch (action) {
			case 'pdf':
				DocOverview.getPdf();
				break;
			case 'print':
				DocOverview.print();
				break;
			case 'email':
				DocOverview.emailSending();
				break;
			case 'postal':
				Mail.sendDoc(docid, 'doc');
				break;
			case 'opportunity':
				DocOverview.createOpportunity();
				break;
			case 'invoiced':
				DocOverview.convert("invoiceForm");
				break;
		}
	},

	prospectConvert: function (docFormUrl, reload = false, cleanUrl = false) {
		var options = {
			type: 'warning',
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Convertir"),
					click: function () {
						var meta = DocOverview.getProperties(['thirdid', 'docid']);
						const relocateUrl = reload ? '' : `${ docFormUrl }&from=${ meta.docid }`;
						Third.transformThird('client', meta.thirdid, '', cleanUrl ? docFormUrl : relocateUrl, reload, cleanUrl);
						$(this).dialog("close");
					}
				}
			]
		}
		MyWindow.alert(Loc.g('Ce devis est destiné à un prospect.') + '<br /><br />' + Loc.g('Vous devez transformer ce prospect en client pour réaliser cette action'), options);
	},

	thirdNotLoadable: function () {
		MyWindow.alert(Loc.g('Le client est supprimé.') + '<br /><br />' + Loc.g('Il n‘est plus possible de créer de document pour lui.'), { type: 'error' });
	},

	getLinkedElements: function (linkedType, docId) {

		var options = {
			width: MyWindow.large,
			title: Loc.g("Liste des documents liés"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				}
			],
			callback: function () {
				MyFacture.loadThirdQtip();
			}
		};
		MyWindow.load("doc", { 'do': "getLinkedElements", 'doctype': linkedType, 'docId': docId }, options);

	},


	getPurchasesLinkedElements: function (linkedType, docId) {

		var options = {
			width: MyWindow.large,
			title: Loc.g("Liste des documents liés"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				}
			],
			callback: function () {
				MyFacture.loadThirdQtip();
			}
		};
		MyWindow.load("purchases_purchases", { 'do': "getLinkedElements", 'doctype': linkedType, 'docId': docId }, options);

	},

	resendFile: function (el, id) {
		$.ajax({
			url: '/?_f=doc',
			data: {
				'action': 'resendFile',
				'id': id
			},
			type: 'POST',
			success: function () {
				el.closest('div.uploadErrorContainer').fadeOut();
			}
		});
	},

	displayUpdateMarginPopup: function (msg, form, url) {
		var options = {
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Continuer"),
					click: function () {
						$.post(url, form, function (response) {
							if (response.form.status == "failed") {
								if (response.form.msg != "") {
									Push.error(response.form.msg);
								}
								else if (response.form.fields.length > 0 && response.form.fields[0].msg) {
									var fieldName = response.form.fields[0].fieldId.split("_");
									Push.error(fieldName[2] + " : " + response.form.fields[0].msg);
								}
							}
							else {
								Utils.reload();
							}
						}, 'json');
					}
				}
			]
		};

		MyWindow.alert(msg, options);
	},

	updateMarginWithPurchase: function (isChecked, docLinkedElemendId) {
		var msg = "";
		var process = "";

		if (isChecked === "Y") {
			msg = Loc.g("Cette action va recalculer les marges de ce document sans prendre en compte l'achat sélectionné");
			process = "N";
		} else {
			msg = Loc.g("Cette action va recalculer les marges de ce document en prenant en compte l'achat sélectionné");
			process = "Y";
		}

		var form = {
			'update_margin_with_docLinkedElemend_docLinkedElemendId': docLinkedElemendId,
			'update_margin_with_docLinkedElemend_processMargin': process
		};

		this.displayUpdateMarginPopup(msg, form, "/?_f=purchases_link&action=updateMarginWithPurchase")
	},

	LoadChildsHistory: function () {

		jsPlumb.ready(function () {

			var color = "gray";

			window.jsplumbinstance = jsPlumb.getInstance({
				// notice the 'curviness' argument to this Bezier curve.  the curves on this page are far smoother
				// than the curves on the first demo, which use the default curviness value.
				anchor: "Perimeter",
				anchors: ["Perimeter"],
				Connector: ["Flowchart", { cornerRadius: 3 }],
				DragOptions: { cursor: "crosshair", zIndex: 2000 },
				PaintStyle: { stroke: "#ABBECA", lineWidth: 3 },
				Endpoint: 'Blank',

				Container: "content_docTree"
			});


			// suspend drawing and initialise.
			jsplumbinstance.batch(function () {

				// declare some common values:

				// add endpoints, giving them a UUID.
				// you DO NOT NEED to use this method. You can use your library's selector method.
				// the jsPlumb demos use it so that the code can be shared between all three libraries.
				var windows = jsPlumb.getSelector("#content_docTree .hdoc");

				for (var i = 0; i < windows.length; i++) {
					var offset = 0;
					if (windows[i].offsetHeight - 90 > 0) {
						offset = (90 - windows[i].offsetHeight) / 2;
					}
					jsplumbinstance.addEndpoint(windows[i], {
						uuid: windows[i].getAttribute("id") + "-right",
						anchor: [1, 0.5, 1, 0, 0, offset], //ensure that lines will be horizontal even if block are not of the same size
						maxConnections: -1
					});
					jsplumbinstance.addEndpoint(windows[i], {
						uuid: windows[i].getAttribute("id") + "-left",
						anchor: [0, 0.5, -1, 0, 0, offset], //ensure that lines will be horizontal even if block are not of the same size
						maxConnections: -1
					});
				}
				var index = 0
				for (var i = 0; i < windows.length; i++) {
					var currentDoc = windows[i].getAttribute("id");
					var parents = JSON.parse(windows[i].getAttribute("data-parents"));
					if (parents.length > 0) {
						for (var cpt = 0; cpt < parents.length; cpt++) {
							if (parents[cpt] != 0) {
								jsplumbinstance.connect({
									uuids: ["hdoc-" + parents[cpt] + "-right", currentDoc + "-left"],
									connector: ["Flowchart", { cornerRadius: 15, stub:[20, 20] }],
								});
							}
						}
					}
				}
			});
			jsPlumb.repaint();
		});
	},

	refreshAgenda: function (startTime, endTime, days, view) {
		if ($('#calendar table').length == 0) {
			Agenda.initCalendar(startTime, endTime, days, view);
		}
	},

	movePayment: function (payrelid, docid, doctype) {


		var options = {
			type: 'warning',
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Continuer"),
					click: function () {

						var data = { action: 'movePayment', payrelid: payrelid, docid: docid, doctype: doctype };

						MyFacture.post('purchases_purchases', data, function (data) {
							Utils.reload();
						}, 'json');
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Voulez vous déplacer ce paiement sur cette facture fournisseur ?'), options);
	},

	invoicePurDeliveries: function (orderid) {

		var options = {
			width: 600,
			title: Loc.g("Facturer les bons de livraison"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Créer la facture"),
					click: function () {
						$("#toInvoiceForm .error").html("").hide();
						var toInvoice = [];
						$(".toInvoice:checked").each(function (e) {
							toInvoice.push($(this).val());
						});
						if (toInvoice.length > 1) {
							$.each(toInvoice, function (e) {
								toInvoice[e] = "pur_" + toInvoice[e];
							});

						} else if (toInvoice.length === 0) {
							var msg = Loc.g("Vous devez sélectionner au moins un document.");
							$("#toInvoiceForm .error").html(msg).show();
							return;
						}
						Utils.relocate("?_f=purchases_purInvoiceForm&from=" + toInvoice.join(','));
					}
				}
			]
		};

		MyWindow.load("purchases_purchases", { 'do': "invoicePurDeliveries", 'docid': orderid, 'doctype': "purOrder" }, options);
	},

	confirmConvertDeliv: function (docFormUrl, step) {

		var options = {
			width: MyWindow.medium,
			type: 'warning',
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Créer un bon de livraison"),
					click: function () {
						DocOverview.convert(docFormUrl);
					}
				},
				{
					text: Loc.g("Changer l‘état de livraison"),
					click: function () {
						DocOverview.toDeliveryStep(step);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Pour changer l‘état de livraison de ce document, vous pouvez créer un bon de livraison ou mettre à jour directement l‘état de livraison. Que voulez vous faire ?"), options);
	},

	confirmConvertStep: function (docFormUrl, step) {

		var options = {
			type: 'warning',
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Créer une facture"),
					click: function () {
						DocOverview.convert(docFormUrl);
					}
				},
				{
					text: Loc.g("Changer l‘état de facturation"),
					click: function () {
						DocOverview.toStep(step, true);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Pour changer l‘état de facturation de ce document, vous pouvez créer une facture fournisseur ou mettre à jour directement l‘état de facturation. Que voulez vous faire ?"), options);
	},

	deleteAllStockMove: function (docId) {
		var options = {
			type: 'warning',
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Non"),
					click: function () {
						DocOverview.toStep('cancelled');
					}
				},
				{
					text: Loc.g("Oui"),
					click: function () {
						MyFacture.post(
							'stock_moveslisting',
							{
								action: 'deleteAllMoveForDoc',
								docleid: docId
							},
							function (data) {
								DocOverview.toStep('cancelled');
							},
							'json'
						);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous supprimer les mouvements de stock associés à ce document ?"), options);
	},


	removeParent: function (linkId) {
		var options = {
			type: 'warning',
			buttons: [
				{
					text: Loc.g("Non"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Oui"),
					click: function () {
						window.SellsyJS.WebServiceCaller.del(`/rest/documents/parent/${linkId}`, {}, (success) => {
							Utils.reload();
						}, (error) => {
							Push.error(Loc.g('Une erreur est survenur : ' + error));
						})
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous délier le document ?"), options);
	},

	/**
	 *
	 * @returns {undefined}
	 */
	manualUpdateStepAndAmount: function (docid, doctype) {

		var options = {
			title: Loc.g('Mise à jour des statuts'),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Mettre à jour"),
					click: function () {
						$("#manualUpdateStepAndAmountForm").submit();
					}
				}
			],
			callback: function () {

				var formId = "manualUpdateStepAndAmountForm";
				var options = {
					success: function (data) {
						var formIsOk = MyForm.processJson(data, "manualUpdateStepAndAmountForm");
						if (formIsOk) {
							MyWindow.close();
						}
					}, dataType: "json"
				};

				var data = { action: 'recordManualUpdateStepAndAmountForm' };
				MyForm.prepare(formId, "doc&" + $.param(data), options, true);

			}
		};

		MyWindow.load("doc", { action: "manualUpdateStepAndAmount", docid: docid, doctype: doctype }, options);

	},


	loadProposalTab: function (doctype, docid) {

		var prefilter = { 'doctype': doctype, 'docid': docid };

		if ($('#proposal_content').html() === '') {
			var options = {
				action: "loadListingTab",
				listing: 'proposal',
				context: 'document',
				prefilter: JSON.stringify(prefilter)
			};

			MyFacture.post('tabs', options, function (data) {
				$('#proposal_content').html(data.listing);
				Listing.init(data.prefix);

				var options = {
					data: {
						action: 'updateListingTab',
						listing: 'proposal',
						context: 'document',
						prefilter: JSON.stringify(prefilter),
					},
					success: function (data) {
						Listing.refresh(data.listingName, data, data[data.metadatasName]);
					},
					dataType: "json"
				};
				MyForm.prepare(data.listingname + "FilterForm", "tabs", options);
				MyFacture.customForm('#proposal_content');
			}, 'json');
		}
	},

	loadAccountingTab: function (doctype, docid, journal) {
		if ($('#accounting_content').html() == '') {
			var options = {
				action: 'loadAccountingTab',
				doctype: doctype,
				docid: docid,
				journal: journal,
			};

			MyFacture.post('accountingJournal', options, function (data) {
				$('#accounting_content').html(data.accountingList);
			}, 'json');
		}
	},


	loadLinkedTab: function (doctype, docid) {

		var options = {
			action: 'loadLinkedTab',
			doctype: doctype,
			docid: docid
		};

		MyFacture.post('doc', options, function (data) {

			if (data.hasPayments === 'Y') {
				$('#deadlinesList .contentlist').html(data.paymentsDeadlines);
				$('#deadlinesList').show();
				DocDeadlines.loadRelatedsQtip();

			}

			if (data.hasPayments === 'Y') {
				$('#paymentsList .contentlist').html(data.paymentsList);
				$('#paymentsList').show();
			}

			if (data.hasDeposits === 'Y') {
				$('#depositsList .contentlist').html(data.depositsList);
				$('#depositsList').show();
			}

			if (data.hasCreditnotes === 'Y') {
				$('#creditnoteList .contentlist').html(data.creditnoteList);
				$('#creditnoteList').show();
			}

			if (data.hasInvoices === 'Y') {
				$('#invoicesList .contentlist').html(data.invoicesList);
				$('#invoicesList').show();
			}

			if (data.hasDocLinked === 'Y') {
				$('#doclinkedList .contentlist').html(data.doclinkedList);
				$('#doclinkedList').show();
			}


			if (data.hasBonuses === 'Y') {
				$("#bonusesList .contentlist").html(data.bonuses);
				$("#bonusesList").show();
			}

		}, 'json');
	},


	toggleStatus: function (status) {

		if ($('#' + status).is(':visible')) {
			$('#' + status).hide();
			$('#' + status + '_toggler i').removeClass('fa-caret-up').addClass('fa-caret-down');
		} else {
			$('#' + status).show();
			$('#' + status + '_toggler i').addClass('fa-caret-up').removeClass('fa-caret-down');
		}
	},


	loadTrackingOverview: function () {

		var data = {
			action: 'statsTracking',
		};

		data = $.extend(true, data, DocOverview.getProperties(['docid', 'doctype', 'rateCategory']));

		$.ajax({
			url: '/?_f=doc',
			type: 'POST',
			data: data,
			dataType: 'json',
			success: function (data) {
				$('#tracking_content').html(data.trackingOverview);
			}
		});
	},

	loadMarginTab: function () {

		var data = {
			action: 'loadMarginTab',
		};

		data = $.extend(true, data, DocOverview.getProperties(['docid', 'doctype']));

		$.ajax({
			url: '/?_f=doc',
			type: 'POST',
			data: data,
			dataType: 'json',
			success: function (data) {
				$('#content_margins').html(data.margins);
				Qtip.init();
			}
		});
	},

	sepaExport: function (docid, doctype) {
		var options = {
			title: Loc.g("Fichier Prélèvement SEPA"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Continuer"),
					click: function () {
						$("#sepaExport").submit();
						$(this).dialog("close");
					}
				}
			],
			callback: function () {

			}
		};

		var fileOpt = { action: "popupSepaExport", docid: docid, doctype: doctype };
		MyWindow.load("sepaexport", fileOpt, options);
	},

	/** @todo : a supprimer */
	editMargins: function (docid, doctype) {
		var options = {
			title: Loc.g("Editer les marges liées au document"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function () {
						$("#editMarginsForm").submit();
					}
				}
			],
			callback: function () {
				DocOverview.prepareEditMargins();
				Qtip.init();
			},
			width: MyWindow.medium
		};

		var fileOpt = { action: "editMarginsForm", docid: docid, doctype: doctype };
		MyWindow.load("purchases_link", fileOpt, options);
	},

	/** @todo : a supprimer */
	prepareEditMargins: function () {
		var formId = "editMarginsForm";

		var options = {
			success: function (data) {
				DocOverview.recordEditMargins(data);
			},
			dataType: "json"
		};
		var params = {
			action: 'editMarginsRecord'
		};
		MyForm.prepare(formId, "purchases_link&" + $.param(params), options, true);
		MyFacture.customForm();
	},

	/** @todo : a supprimer */
	recordEditMargins: function (data) {
		var formIsOk = MyForm.processJson(data, "editMarginsForm");

		if (formIsOk) {
			MyWindow.close();

			var newLocation = './' + window.location.search;
			var newLocation = newLocation.split('&editMargins')[0];
			Utils.relocate(newLocation);
		}
	},

	togglePublicLink: function (doctype, docid, publiclinkavailable) {

		if (publiclinkavailable == undefined) {

			var opt = {
				title: Loc.g("Activer/désactiver le lien public"),
				buttons: [
					{
						text: Loc.g("Annuler"),
						click: function () {
							$(this).dialog("close");
						}
					},
					{
						text: Loc.g("Enregistrer"),
						click: function (btn) {
							var toActivate = $('#massTogglePublicLink option:selected').val();
							DocOverview.togglePublicLink(doctype, docid, toActivate);
						}
					}
				]
			};

			var content =
				"<fieldset>" +
				"<legend>" + Loc.g("Lien public") + "</legend>" +
				"<div class='form-group'>" +
				"<div class='form-input'>" +
				"<select id='massTogglePublicLink'>" +
				"<option value='Y'>" + Loc.g("Activer") + "</option>" +
				"<option value='N'>" + Loc.g("Désactiver") + "</option>" +
				"</select>" +
				"</div>" +
				"</div>" +
				"</fieldset>";

			MyWindow.alert(content, opt);

			return;
		}

		// DEFINE ACTION TO CALL IN FUNCTION OF IS DOCID IS UNIQUE OR AN ARRAY
		var isMassAction = Array.isArray(docid);

		MyFacture.post("doc", { action: 'togglePublicLink', docid: docid, doctype: doctype, publiclinkavailable: publiclinkavailable }, function (data) {

			if (data.error !== undefined) {
				MyWindow.alert(Loc.g("Une erreur est survenue") + ":<br/>" + data.error, { type: "error" });
				return;
			}

			if (isMassAction) {
				var options = {
					title: Loc.g("Accès public aux documents"),
					type: 'confirm',
					buttons: [
						{
							text: Loc.g("Ok"),
							click: function () {
								$(this).dialog("close");
								Listing.update($($('[name=listingName]')[0]).attr('value'))
							}
						}
					]
				};

				MyWindow.alert(Loc.g("Le lien public a été ") + (data.publicLinkAvailable === 'Y' ? Loc.g("activé") : Loc.g("désactivé")) + " " + Loc.g("pour les documents sélectionnés"), options);

			} else if (data.publicLinkAvailable) {
				switch (data.publicLinkAvailable) {

					case "Y":
						$('.publicLinkToggle.toggleOff').show();
						$('.publicLinkToggle.toggleOn').hide();
						break;

					case "N":
						$('.publicLinkToggle.toggleOff').hide();
						$('.publicLinkToggle.toggleOn').show();
						break;
				}
			}

		}, "json");
	}

};

window.DocTracking = {
	start: null,

	init: function (docid) {

		var url = location.protocol + '//' + location.hostname + '/?_f=tracking';

		var date = new Date();
		DocTracking.start = Math.floor(date.getTime() / 1000);

		$(window).bind('unload', function (event) {

			var date = new Date();
			var current = Math.floor(date.getTime() / 1000);
			var duration = (current - DocTracking.start);

			var data = {
				action: 'document',
				docid: docid,
				duration: duration,
				start: DocTracking.start,
				end: current
			};

			$.ajax({
				type: 'POST',
				url: url,
				data: data,
				async: false
			});
		});
	},

	download: function (doctype, docid) {
		var url = location.protocol + '//' + location.hostname + '/tracking';

		var data = {
			doctype: doctype,
			docid: docid
		};

		$.ajax({
			type: 'POST',
			url: url + '/download',
			data: data,
			async: false
		});
	}
};
